module.exports = __webpack_public_path__ + "media/costreaming/costreaming-44b9956a.png";